import { render, staticRenderFns } from "./EditTransaction.vue?vue&type=template&id=12d266f6"
import script from "./EditTransaction.vue?vue&type=script&lang=js"
export * from "./EditTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports